<button
  [type]="'button'"
  class="x-button"
  (click)="buttonClick.emit()"
  [style.width.px]="width"
  [style.height.px]="width"
>
  <oph-icon name="x-light-brown" class="x-brown"></oph-icon>
  <oph-icon name="x-red" class="x-red"></oph-icon>
</button>
